import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// GET /ajax/grades/{district_id}
export const grades = async (districtId: TDistrictId) => {
  const response = await new Request().get('/ajax/grades/' + districtId)
  return Util.Obj.keysToCamel(response.data.grades) as TGrade[]
}
